const BASE = 'WPT/APPLICATION/APPLICATION';
const INIT = `${BASE}_INIT`;
const READY = `${BASE}_READY`;
const RESET = `${BASE}_RESET`;

export {
  BASE, INIT, READY, RESET,
};
